import DriverMedalsApi from "../../services/api/DriverMedals";
import qs from "qs";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in driver medals actions:", err);
}

export const setDriverMedalsDetails = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_MEDALS_DETAILS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_DRIVER_MEDALS,
    payload,
  };
};

export const getDriverMetaData =
  (finalPayload = {}) =>
  async (dispatch) => {
    try {
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
      });
      dispatch(setLoader(true));
      let response = await DriverMedalsApi.getDriverMetaData(queryParamsString);
      dispatch(setLoader(false));
      if (response) {
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getDriverMedalsDetails =
  (filters = {}) =>
  async (dispatch) => {
    try {
      const queryParamsString = qs.stringify(filters, {
        addQueryPrefix: true,
      });
      dispatch(setLoader(true));
      let response = await DriverMedalsApi.getDriverMedalsDetails(
        queryParamsString
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setDriverMedalsDetails(response));
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
